import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { ExternalLink } from "lucide-react";
import { useDocumentSheetContext } from "@/shared/bsm/core/document/components/ui/document-sheet";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { useDocumentPath } from "@/services/backend/documents/components/use-document-path";
import { DocumentKind } from "@bitory-gmbh/bsm";
import { useNavigateToDocument } from "@/services/backend/documents/components/preview/_components/navigate-to-document-context";

export interface NavigateToDocumentButtonProps {
  documentId: string;
  documentKind: DocumentKind;
  serviceKind: GSMServiceKind;
  processId: string | null;
}

export function NavigateToDocumentButton({
  documentId,
  documentKind,
  serviceKind,
  processId,
}: NavigateToDocumentButtonProps) {
  const { setOpen } = useDocumentSheetContext();
  const onNavigate = useNavigateToDocument();

  const { path } = useDocumentPath({
    documentId,
    documentKind,
    serviceKind,
    processId,
  });

  if (!path || !onNavigate) {
    return null;
  }

  return (
    <Button
      className="w-full"
      onClick={() => {
        setOpen(false);
        onNavigate(path);
      }}
    >
      <span>{t("Zum Vorgang navigieren")}</span>
      <ExternalLink className="ml-2 h-4 w-4" />
    </Button>
  );
}
